import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import i18next from 'i18next';
import { call, all, put, select, getContext } from 'redux-saga/effects';
import { requestPuppy, isApiError, requestNapi } from '@wix/da-http-client';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { withOffset, selectors } from '../../Stream';
import { normalizeGallection } from '../../redux/normalizr/helpers';
import { addErrorNotification } from '../../Notifications/redux/actionCreators';
import { getCurrentMediaSource, getCurrentFolderId, getNonManageablePrependedGallectionsCount, getGrusername } from '../selectors';
import { getGallectionStreamId, getGallectionDeviationStreamId, getGallectionType } from '../helpers';
import { MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, DEVIATIONS_PER_FETCH } from '../constants';
import { getStreamInitAction } from './initGallectionStream';
import { fromPlainText } from '@wix/da-editor-tiptap/pkg/components/utils/helpers';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';
export function fakeResponse({ data }) {
    if (process.env.NODE_ENV !== 'production') {
        const { galleries } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const response = {
            success: true,
            gallection: _object_spread_props(_object_spread({}, galleries[3]), {
                folderId: -1000,
                name: data.name
            })
        };
        return response;
    }
}
function* createGallection(action) {
    const { payload } = action;
    if (!payload) {
        return;
    }
    const mediaSource = yield select(getCurrentMediaSource);
    const currentFolderId = yield select(getCurrentFolderId);
    const username = yield select(getGrusername);
    const gallectionsStreamId = getGallectionStreamId(mediaSource, currentFolderId);
    const isEditorGallection = yield select(flagEnabled, 'editor_gallection');
    var _getGallectionType;
    const params = {
        type: (_getGallectionType = getGallectionType(mediaSource)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        name: payload.name,
        username
    };
    if (currentFolderId) {
        params['parent_folder_id'] = currentFolderId;
    }
    if (payload.folderType !== 'regular') {
        params['premium_type'] = payload.folderType;
        if (payload.folderType === 'paid') {
            params['points_price'] = payload.priceInPoints;
        }
    }
    let result;
    if (isEditorGallection) {
        params.description = fromPlainText('').html.markup;
        result = yield call(requestNapi, {
            method: 'post',
            url: 'gallection/folders/create',
            data: params
        }, undefined);
    } else {
        result = yield call(requestPuppy, {
            method: 'post',
            url: 'gallection/folders/create',
            data: params
        }, fakeResponse);
    }
    if (!result || !result.success || !result.gallection) {
        if (isApiError(result)) {
            const { errorDescription } = result;
            const externalDispatch = yield getContext('externalDispatch');
            yield call(yieldToMainAsync);
            yield call(externalDispatch, addErrorNotification(i18next.t('mediapopup.gallections.error.new', {
                errorDescription
            })));
        }
        return;
    }
    const newGallection = _object_spread_props(_object_spread({}, result.gallection), {
        parentId: currentFolderId !== null && currentFolderId !== void 0 ? currentFolderId : null,
        permissions: {
            createFolder: true,
            viewFolder: true,
            editFolder: true,
            deleteFolder: true,
            contributeDeviations: true,
            recommendDeviations: true
        }
    });
    const entities = normalizeGallection(newGallection);
    const nonManageableGallectionsCount = yield select(getNonManageablePrependedGallectionsCount);
    const gallectionDeviationsStreamId = getGallectionDeviationStreamId(mediaSource, newGallection.folderId);
    const putActions = [];
    if (currentFolderId) {
        const isGallectionStreamInitialized = yield select(selectors.isInitialized, gallectionsStreamId);
        if (!isGallectionStreamInitialized) {
            putActions.push(put(getStreamInitAction(mediaSource, currentFolderId)));
        }
    }
    const streamParams = {
        mediaSource,
        folderId: newGallection.folderId
    };
    putActions.push(put(withOffset.actions.insertItems({
        streamId: gallectionsStreamId,
        items: [
            newGallection.folderId
        ],
        entities,
        offset: nonManageableGallectionsCount
    })), put(withOffset.actions.initialize({
        streamId: gallectionDeviationsStreamId,
        groupId: MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP,
        streamParams,
        items: [],
        itemsPerFetch: DEVIATIONS_PER_FETCH,
        hasMore: false
    })));
    yield all(putActions);
}
export default createGallection;

//# sourceMappingURL=createGallection.js.map